/*
 *   File : confirm-cancel-sip.js
 *   Author : https://evoqins.com
 *   Description : SIP cancel confirmation modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useState } from "react";
import { toast } from "react-toastify";

// Components
import { APIService } from "../../Service";
import { PrimaryButton, SecondaryButton } from "../Buttons";
import { Icon } from "../Icon"

function ConfirmCancelSIPModal(props) {

    const [loader, setLoader] = useState(false);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("sip-cancel-confirm-modal-close");
        button.click();
        props.handleClose();
    };

    // handle cancel sip
    const _handleCancelSIP = () => {
        setLoader(true)
        // API 
        _cancelActiveSIP();
    };

    /////////////////////////////////
    //  API  -  Get active list data //
    const _cancelActiveSIP = async () => {
        let url = "portfolio/stop-sip";
        let data = {
            "user_id": props.selectedSIP.user_id,
            "portfolio_id": props.selectedSIP.portfolio_id,
            "sip_id": Number(props.selectedSIP.sip_id),
            "tenant_id": Number(props.selectedSIP.creator_id),
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {

            var button = document.getElementById("sip-cancel-confirm-modal-close");
            button.click();
            props.handleSuccess();

            toast.dismiss();
            toast.success(`${props.selectedSIP.strategy_name} SIP cancelled successfully`);
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setLoader(false);

    };



    return (
        <div className="modal fade"
            id="sip-cancel-confirm-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SipRestartModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='sip-cancel-confirm-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 text-center'>
                        <img src={require("../../Assets/Images/Modal/confirm-sip-cancel.png")}
                            draggable={false}
                            width={200}
                            alt='broker' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            Confirm SIP Cancellation
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            Are you sure you want to cancel your SIP? Please consider how this might affect your long-term financial goals. Are you sure you want to proceed?
                        </p>
                    </div>
                    {/* Modal footer */}
                    <div className='modal-footer border-0 padding-40px-lr padding-20px-tb d-block'>
                        <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3">

                            <SecondaryButton name="Keep SIP Active"
                                className="h-56 w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                padding="padding-18px-tb e-padding-8px-all-res"
                                onPress={_handleCloseModal} />
                            <PrimaryButton name="Confirm"
                                status={loader}
                                disabled={loader}
                                className="h-56 w-100 flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res"
                                padding="padding-18px-tb e-padding-8px-all-res"
                                onPress={_handleCancelSIP} />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmCancelSIPModal